import VTableCard from '@/vuetify_custom/v-table-card'
import { VSpacer } from 'vuetify/lib'
import VRippleCol from '@/vuetify_custom/v-ripple-col';
import {mapGetters} from "vuex";
import styles from './index.module.less'
import {THRID} from './constants'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        target: {
            type: Object,
            default: () => ({})
        },
        entryType: {
          type: String,
        }
    },
    computed: {
      ...mapGetters({
        teams_hash: 'async/root_teams_hash',
      }),
        tableCardFields() {
            let base = [
                {
                  label: '收款平台',
                  key: 'receipt_platform',
                },
                {
                  label: '平台分成比例（单位：%）',
                  key: 'sharing_percent',
                },
                {
                  label: '收款手续费比例（单位：%）',
                  key: 'fee_percent',
                },
                {
                  label: '结算方式',
                  key: 'payment_means',
                },
                {
                  label: '收款团队',
                  key: 'shouku_id'
                },
                {
                  label: '收款账户',
                  key: 'payee_company_account_id'
                },
                {
                  label: '收款对接人',
                  key: 'payee_user_id',
                  type: 'customer_name_field',
                },
                {
                  label: '对账频率',
                  key: 'frequency',
                  show: this.entryType === THRID
                },
                {
                  label: '开票主体',
                  key: 'invoice_company_id',
                  type: 'company_field',
                },
                {
                  label: '售卖类型',
                  key: 'sale_type',
                  type: 'select_field',
                  text_key: 'label',
                  value_key: 'value',
                  items:[
                      {
                          label: '实体商品',
                          value: 'reality'
                      },
                      {
                          label: '课程',
                          value: 'course'
                      },
                      {
                          label: '会员',
                          value: 'member'
                      },
                      {
                          label: '其他',
                          value: 'other'
                      }
                  ],
                },
                {
                 //  show: this.target && (this.target.sale_type === 'other'),
                  label: '商品描述',
                  key: 'sale_type_other'
                },
                {
                  show: this.target && (this.target.sale_type === 'reality'),
                  label: '发货方',
                  key: 'deliver_type',
                  type: 'select_field',
                  text_key: 'label',
                  value_key: 'value',
                  items:[
                      {
                          label: '我司仓库',
                          value: 'own'
                      },
                      {
                          label: '第三方代发',
                          value: 'drop_shipping'
                      },
                  ],
                },
                // --
           ]
           base = base.map(i => {
             if (i.show === undefined) {
              i.show = true
             }
             return i
           })
           return base.filter(i => i.show)
        }
    },
   
    render() {
        const _this = this
      
        return <VTableCard 
                    sub-title="收款信息【财务】"
                    value={_this.target}
                    fields={_this.tableCardFields}
                    cols={4}
                    scopedSlots={{
                      shouku_id: ({field, value}) => {
                        const team_id = (_this.target || {})['team_id']
                        const team = (this.teams_hash || {})[team_id] || {}
                
                        return (<VRippleCol
                          md="12"
                          cols="12"
                        >
                          {field.label}
                          <VSpacer/>
                          <div>
                            <p class={styles['p-no-margin']}>
                              {team.name}
                            </p>
                          </div>
                        </VRippleCol>)
                      },
                      payee_company_account_id:({field, value}) => {
                        return (<VRippleCol
                          md="12"
                          cols="12"
                        >
                          {field.label}
                          <VSpacer/>
                          <div>
                            <p class={styles['p-no-margin']}>
                              {value.payee_account_name}
                            </p>
                            <p class={styles['p-no-margin']}>
                              {value.payee_bank_number}
                            </p>
                          </div>
                        </VRippleCol>)
                      }
                    }}
                />
    }
}